

import React, { Suspense, useState, useEffect, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import TitleHelmet from '../../components/UI/TitleHelmet/TitleHelmet';
import { EMBody, EMContainer, EMTableContainer, NavButton, ButtonRow, ModalBox, Overlay, Header, Button, TitleHeader, Message, OptionButton, HeaderLocation, QuestionText, IndexQuestion } from './EnqueteDeSatisfaction.styled';
import { Spinner } from 'react-bootstrap';
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from 'styled-components';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import NearMeIcon from '@mui/icons-material/NearMe';
import Axios from '../../axios-proas';
import { getNotyfObject } from '../../shared/utility';
import AlreadyAnsweredMessage from '../../components/EnqueteDeSatisfaction/AlreadyAnsweredMessage';
function EnqueteDeSatisfaction(props) {
    const { connectedUserId, enquete_id, URL
    } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isResponseSent, setIsResponseSent] = useState(false)
    const theme = useTheme();
    const [enquete, setEnquete] = useState()
    const notyf = getNotyfObject();
    const [hasAnswered, setHasAnswered] = useState(false)
    const [questions, setQuestions] = useState(
        [
            {
                id: 1,

                text: "D’une manière générale, vous jugez que votre logement est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,

            },
            {
                id: 2,
                text: "Vous estimez que l’état du logement au moment de votre entrée était :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 3,
                text: "En ce qui concerne la surface de votre logement, vous considérez qu’elle est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 4,
                text: "Vous considérez que l’agencement des pièces de votre logement est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 5,
                text: "Vous jugez que les performances thermiques (le chauffage, l’isolation) de votre logement sont :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 6,
                text: "Vous jugez que les performances phoniques (l’isolation sonore) de votre logement sont :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 7,
                text: "Votre appréciation sur les équipements de votre logement, dont les rangements, est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 8,
                text: "Vous considérez que le niveau d’entretien de la résidence et des équipements communs est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 9,
                text: "Vous jugez que le quartier dans lequel est situé votre logement est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 10,
                text: "Par rapport aux transports en commun, vous jugez la localisation de votre logement :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 11,
                text: "En ce qui concerne la proximité des commerces et des services publics (école, mairie…), vous jugez la localisation de votre logement :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 12,
                text: "Vous estimez que le niveau du loyer, par rapport au quartier et aux services offerts, est :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 13,
                text: "Au niveau des contacts avec votre gestionnaire, vous considérez que les relations sont :",
                options: ["Très satisfaisant (e)", "Satisfaisant (e)", "Peu satisfaisant (e)", "Insatisfaisant (e)"],
                isMulti: false,
            },
            {
                id: 14,
                text: "Dans les 2 prochaines années, envisagez-vous de rester dans votre logement actuel ?",
                options: ["Oui", "Non"],
                isMulti: false,
                show: true,
            },
            {
                id: 15,
                text: "Dans la négative, pour quelle raison envisagez-vous de quitter votre logement ?",
                options: [
                    "Insatisfaction du logement actuel",
                    "Changement de situation familiale",
                    "Accession à la propriété",
                    "Mobilité professionnelle",
                    "Autre",
                ],
                isMulti: false,
                show: false,
            },
            {
                id: 16,
                text: "Et si votre logement était proposé à la vente, seriez-vous intéressé par son acquisition ?",
                options: ["Oui", "Non"],
                isMulti: false,
                show: true,
            },
            {
                id: 17,
                text: "Envisagez-vous d’utiliser d’ici un an max une voiture électrique nécessitant l’installation d’une borne de recharge dans le parking de votre habitation ?",
                options: ["Oui", "Non", "Non concerné"],
                isMulti: false,
                show: true,
            },
            {
                id: 18,
                text: "Savez-vous que vous occupez un logement appartenant à Foncière Logement ?",
                options: ["Oui", "Non"],
                isMulti: false,
                show: true,
            },
            {
                id: 19,
                text: "Recommanderiez-vous Foncière Logement à une connaissance en recherche d’une location ?",
                options: ["Oui tout à fait", "Oui plutôt", "Non plutôt pas", "Non pas du tout"],
                isMulti: false,
                show: true,
            },
        ]
    )
    const [step, setStep] = useState(0);
    const [answers, setAnswers] = useState({});
    const q = questions[step];

    //const handleSelect2 = (opt) => {
    //    const current = questions[14];
    //    if (current.isMulti) {
    //        const prev = answers[current.id] || [];
    //        const newAnswers = prev.includes(opt)
    //            ? prev.filter((o) => o !== opt)
    //            : [...prev, opt];
    //        setAnswers({ ...answers, [current.id]: newAnswers });
    //    } else {

    //        if (answers[current.id] == opt) {
    //            setAnswers({ ...answers, [current.id]: null });

    //        } else {
    //            setAnswers({ ...answers, [current.id]: opt });

    //        }

    //    }
    //};

    const handleSelect = (opt) => {
        const current = questions[step];
        if (current.isMulti) {
            const prev = answers[current.id] || [];
            const newAnswers = prev.includes(opt)
                ? prev.filter((o) => o !== opt)
                : [...prev, opt];
            setAnswers({ ...answers, [current.id]: newAnswers });

        } else {

            if (answers[current.id] == opt) {
                setAnswers({ ...answers, [current.id]: null });

            } else {
                setAnswers({ ...answers, [current.id]: opt });

            }

        }
    };

    const handleNext = () => {
        if (step == 13) {
            const current = questions[step];
            let p = answers[current.id]
            if (p == 'Non') {
                setStep((s) => s + 1);
            } else {
                setStep((s) => s + 2);
            }

        } else

            setStep((s) => s + 1);
    }

    const handlePrev = () => {
        if (step == 15) {
            const current = questions[13];
            let p = answers[current.id]
            if (p == 'Non') {
                setStep((s) => s - 1);
            } else {
                setStep((s) => s - 2);

            }
        } else
            setStep((s) => s - 1);
    }

    useEffect(() => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `EnqueteSatisfactionFcls/userId/${connectedUserId}`, {
            params: null,
            headers: {
                "X-CSRF": "1",
            },
        }).then(res => {
            console.log(res.data.length)
            if (res.data.length > 0) {
                setHasAnswered(true)
            }
            setIsLoading(false)
        }).catch(errs => {
            notyf.error("Une erreur s'est produite");
        })

        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Enquetes/${enquete_id}`, { params: null, headers: { "X-CSRF": "1", }, }).then(res => {
            setEnquete(res.data)
            console.log(res.data?.programme)
        }).catch(errs => {
            notyf.error("Une erreur s'est produite");
        })
    }, [connectedUserId])

    const handleConfirm = () => {
        setShowConfirm(false);
        const recommandationMap = {
            "Insatisfaisant (e)": 1,
            "Peu satisfaisant (e)": 2,
            "Satisfaisant (e)": 3,
            "Très satisfaisant (e)": 4,
            "Oui tout à fait": 1,
            "Oui plutôt": 2,
            "Non plutôt pas": 3,
            "Non pas du tout": 4,
            "Non concerné": 3,
            "Non": 2,
            "Oui": 1,
            "Insatisfaction du logement actuel": 1,
            "Changement de situation familiale": 2,
            "Accession à la propriété": 3,
            "Mobilité professionnelle": 4,
            "Autre": 5,

        };
        let showQ15 = answers["14"] === "Oui" ? false : answers["14"] === "Non" ? true : false;
        const form = {
            userId: connectedUserId,
            source: 1,
            refProgramme: enquete?.programme || "",
            q1: recommandationMap[answers["1"]] || null,
            q2: recommandationMap[answers["2"]] || null,
            q3: recommandationMap[answers["3"]] || null,
            q4: recommandationMap[answers["4"]] || null,
            q5: recommandationMap[answers["5"]] || null,
            q6: recommandationMap[answers["6"]] || null,
            q7: recommandationMap[answers["7"]] || null,
            q8: recommandationMap[answers["8"]] || null,
            q9: recommandationMap[answers["9"]] || null,
            q10: recommandationMap[answers["10"]] || null,
            q11: recommandationMap[answers["11"]] || null,
            q12: recommandationMap[answers["12"]] || null,
            q13: recommandationMap[answers["13"]] || null,
            q14: answers["14"] === "Oui" ? true : answers["14"] === "Non" ? false : null,
            q15: showQ15 ? (recommandationMap[answers["15"]] || null) : null,

            //q15_InsatisfactionLogement: showQ15 ? answers["15"]?.includes("Insatisfaction du logement") || false : null,
            //q15_AccessionPropriete: showQ15 ? answers["15"]?.includes("Accession à la propriété") || false : null,
            //q15_ChangementSituationFamiliale: showQ15 ? answers["15"]?.includes("Changement de situation familiale") || false : null,
            //q15_MobilitePro: answers["15"]?.includes("Mobilité professionnelle") || false,
            //q15_Autre: answers["15"]?.includes("Autre") || false,

            q16: answers["16"] === "Oui" ? true : answers["16"] === "Non" ? false : null,
            q17: recommandationMap[answers["17"]] || null,
            q18: answers["18"] === "Oui" ? true : answers["18"] === "Non" ? false : null,
            q19: recommandationMap[answers["19"]] || null
        };
        Axios.post(import.meta.env.VITE_PREFIX_SERVER_API + 'EnqueteSatisfactionFcls', { ...form }).then(response => {
            setIsResponseSent(true)
            setHasAnswered(true)
            notyf.success("Votre réponse a bien été envoyée !");
        }).catch(errs => {

            notyf.error("Une erreur s'est produite");
        })
    };

    const handleCancel = () => {
        setShowConfirm(false);
    };
    const handleSend = () => {
        setShowConfirm(true);


    }

    return (
        <EMContainer >
            {isLoading ?
                (
                    <Suspense fallback={(<div>loading ...</div>)}> </Suspense>
                ) :
                hasAnswered ? <AlreadyAnsweredMessage URL={URL} isResponseSent={isResponseSent} /> :
                    <>
                        <Header>
                            <HeaderLocation>{"Enquête de satisfaction locataires "}<br />
                                <TitleHeader >
                                    Temps de réponse estimé : environ 2 minutes
                                </TitleHeader>
                            </HeaderLocation>
                        </Header>

                        <EMBody>
                            <EMTableContainer>
                                <Box sx={{ width: "100%", mb: 2 }}>
                                    <Typography variant="body2" color="text.secondary" >
                                        Question {step + 1} / {questions.length}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={(step / questions.length) * 100}
                                        sx={{
                                            height: 15,
                                            borderRadius: 5,
                                            backgroundColor: "#eee",
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: theme.colors.success, // ton rouge Fonci re Logement
                                            },
                                        }}
                                    />
                                </Box>


                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={q.id}
                                        initial={{ opacity: 0, x: 500 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -50 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <QuestionText> <IndexQuestion>Q_{step + 1} </IndexQuestion>{q.text}</QuestionText>
                                        <div style={{ background: "#f8f9fa", padding: "12px" }}>
                                            {q.options.map((opt, i) => (
                                                <OptionButton
                                                    key={i}
                                                    onClick={() => handleSelect(opt)}
                                                    selected={q.isMulti ? answers[q.id]?.includes(opt) : answers[q.id] === opt}
                                                >
                                                    {opt}
                                                </OptionButton>
                                            ))}
                                            {/*{q.id === 14 && answers[q.id]=='Non' && (*/}
                                            {/*    <>*/}
                                            {/*        <QuestionText>*/}
                                            {/*            <IndexQuestion>Q_{step + 2}</IndexQuestion> {questions[14].text}*/}
                                            {/*        </QuestionText>*/}

                                            {/*        {questions[14].options.map((opta, i) => (*/}
                                            {/*            <OptionButton*/}
                                            {/*                key={i}*/}
                                            {/*                onClick={() => handleSelect2(opta)}*/}
                                            {/*                selected={q.isMulti ? answers[q.id]?.includes(opta) : answers[q.id] === opta}*/}
                                            {/*            >*/}
                                            {/*                {opta}*/}
                                            {/*            </OptionButton>*/}
                                            {/*        ))}*/}
                                            {/*    </>*/}
                                            {/*)}*/}
                                        </div>
                                    </motion.div>
                                </AnimatePresence>

                                <ButtonRow>
                                    <NavButton onClick={handlePrev} disabled={step === 0}>
                                        <ArrowLeftIcon /> Précédent
                                    </NavButton>
                                    <NavButton
                                        primary={true}
                                        onClick={step === questions.length - 1 ? handleSend : handleNext}
                                    >
                                        {step === questions.length - 1 ? "Envoyer" : "Suivant"} {step === questions.length - 1 ? <NearMeIcon /> : <ArrowRightIcon />}
                                    </NavButton>
                                </ButtonRow>

                            </EMTableContainer>
                        </EMBody>
                    </>
            }

            {showConfirm && (
                <Overlay>
                    <ModalBox>
                        <h3>Confirmation d’envoi</h3>
                        <Message>
                            Êtes-vous sûr de vouloir envoyer votre réponse à l’enquête ?
                        </Message>
                        <ButtonRow>
                            <Button variant="cancel" onClick={handleCancel}>
                                Retour
                            </Button>
                            <Button variant="confirm" onClick={handleConfirm}>
                                Confirmer
                            </Button>

                        </ButtonRow>
                    </ModalBox>
                </Overlay>
            )}
        </EMContainer>
    )
}

const mapStateToProps = (state) => ({
    connectedUserId: state.auth.connectedUserId,
    enquete_id: state.auth.enquete_id,
    URL: state.auth.URL,
})
const mapDispatchToProps = dispatch => ({

})
export default connect(mapStateToProps, mapDispatchToProps)(EnqueteDeSatisfaction)
